import React, { useContext, useState } from "react";
import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { AppContext } from "../../ContextApi/AppContext/AppContext";

const CustomSelectChip = ({
  multiple = "true",
  label,
  onChange,
  onDelete = () => { },
  name,
  type = "select",
  value,
  listArray,
  disabled,
  index,
  error,
}) => {
  const { state, setState } = useContext(AppContext);
  const { stepLanguage, language } = state;
  return (
    <FormControl
      size="small"
      error={error}
      style={{ width: "100%" }}
    >
      <InputLabel id="demo-multiple-chip-label">{label}</InputLabel>
      <Select
        sx={{
          ".MuiSelect-select": {
            // padding: "11.5px 14px",
            minHeight: "32px",

          },
        }}
        labelId="demo-multiple-chip-label"
        id="demo-multiple-chip"
        label={label}
        disabled={disabled}
        index={index}
        // size="small"
        multiple={multiple}
        value={value || []}
        onChange={(e) => onChange(e)}
        name={name}
        input={
          <OutlinedInput
            id="select-multiple-chip"
            label={label}
          // style={{ height: "60px", textAlign:"center" }}
          />
        }
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected?.map((value) => {
              return (
                // <Chip
                //   key={value.user.id}
                //   label={value?.user?.first_name}
                // />
                <Chip
                  label={language=="de"?value?.german_title:value?.title}
                  key={value.id}
                  deleteIcon={
                    <CancelIcon
                      onMouseDown={(event) => event.stopPropagation()}
                    />
                  }
                  onDelete={() => onDelete(value?.id, name)}
                />
              );
            })}
          </Box>
        )}
      // MenuProps={MenuProps}
      >
        {listArray?.map((item, key) => (
          <MenuItem
            key={key}
            value={item}
          // style={getStyles(name, personName, theme)}
          >
            {language == "de" ? item?.german_title : item?.title}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{error}</FormHelperText>
    </FormControl>
  );
};

export default CustomSelectChip;

const dummyData = [
  {
    id: 1,
    title: "Data",
  },
  {
    id: 2,
    title: "Data2",
  },
  {
    id: 3,
    title: "Data3",
  },
];
